import { render, staticRenderFns } from "./complaint_suggestion_handle.vue?vue&type=template&id=2975e2ff&scoped=true"
import script from "./complaint_suggestion_handle.vue?vue&type=script&lang=js"
export * from "./complaint_suggestion_handle.vue?vue&type=script&lang=js"
import style0 from "./complaint_suggestion_handle.vue?vue&type=style&index=0&id=2975e2ff&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2975e2ff",
  null
  
)

export default component.exports